import Usuario from "model/administracao/cadastro/Usuario";
import Documento from "./Documento";
import { BaseModel } from "model/BaseModel";

export default class DocumentoSolicitacaoRevisao implements BaseModel {
    id: number;
    codigo: string | null = "";
    dataGeracao: Date | null;
    dataResposta: Date | null;
    descricao: string;
    resposta: string|null; 
    observacaoResposta: string | null;
    documento: Documento | null;
    usuarioSolicitacao: Usuario | null;
    usuarioResposta: Usuario | null;
    
    constructor() {
        this.id = 0;
        this.dataGeracao = null;
        this.dataResposta = null;
        this.descricao = '';
        this.resposta = null;
        this.observacaoResposta = null;
        this.documento = null;
        this.usuarioSolicitacao = null;
        this.usuarioResposta = null;
    }
}